import { getLocaleUrl } from "@wbly/common";
import type { Hit } from "instantsearch.js";
import type { Marketplace } from "@wbly/common";
import type { AlgoliaProduct } from "../types/algolia-product";
import {
  ALGOLIA_PARAM_QUERY,
  ALGOLIA_PARAM_SKU,
  ALGOLIA_PARAM_INDEX,
} from "./algolia-analytics";

export function getProductUrl(
  marketplace: Marketplace,
  hit: Hit<AlgoliaProduct>
) {
  const params = new URLSearchParams({
    [ALGOLIA_PARAM_QUERY]: hit.__queryID,
    // This objectID matches the solidus master sku
    [ALGOLIA_PARAM_SKU]: hit.objectID,
    [ALGOLIA_PARAM_INDEX]: marketplace.algoliaIndex,
  });
  return getLocaleUrl(
    marketplace.identifier,
    `/personalized-products/${hit.prismicProductSlug}?${params.toString()}`
  );
}
